import {AnyAction} from "redux";
import {ThunkAction, ThunkDispatch} from "redux-thunk";

import {
    supplierIdChange,
    supplierIdChangeFailed,
    userLogin,
    userLoginFailed,
    userSave,
    userSaveFailed
} from "./user/actions";
import {AppState} from "./";
import {User} from "./user/types";
import axios from "axios";

export const thunkUserSave = (
    user: User
): ThunkAction<void, AppState, null, AnyAction> => async dispatch => {
    let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/accounts/'+user.login|| '';
    axios.put(url, user)
        .then(res => {
            if (res.status == 200) {
                if (res.data) {
                    console.log(res.data);
                    dispatch(userSave(res.data));
                } else {
                    dispatch(userSaveFailed('Server error: user null'));
                }
            } else {
                dispatch(userSaveFailed('Server error: ' + res.status));
            }
        })
        .catch(err => {
            console.log(err);
            dispatch(userSaveFailed('Server error: ' + err));
        })
};

// thunk action
export const thunkUserLogin = (user: User): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    // Invoke API
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
      return new Promise<void>((resolve) => {
        let loginUser = {
            login: user.login,
            password: user.password
        };
        let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/authentication/login' || '';
        axios.post(url, loginUser)
            .then(res => {
                if (res.status == 200) {
                    if (res.data.user) {
                        dispatch(userLogin(res.data.user));
                    } else {
                        dispatch(userLoginFailed('Server error: user null'));
                    }
                } else {
                    dispatch(userLoginFailed('Server error: ' + res.status));
                }
                resolve();
            })
            .catch(err => {
                console.log(err);
                dispatch(userLoginFailed('Server error: ' + err));
                resolve();
            })
      })
    }
  }

export const thunkSaveSupplierId = (supplierId: string): ThunkAction<void, AppState, null, AnyAction> => async dispatch => {
    let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/viewers/supplierId' || '';
    let supplier2View = {
        supplierId2view:supplierId
    }
    axios.put(url, supplier2View)
        .then(res => {
            if (res.status == 204) {
                console.log(res.data);
                dispatch(supplierIdChange(supplierId));
            } else {
                dispatch(supplierIdChangeFailed('Server error: ' + res.status));
            }
        })
        .catch(err => {
            console.log(err);
            dispatch(supplierIdChangeFailed('Server error: ' + err));
        })
};



